import React from 'react';
import CorporateSalesRefundsContainer from
    '../../containers/CorporateSalesContainer/CorporateSalesRefundsContainer/CorporateSalesRefundsContainer';

const CorporateSalesRefundsListPage = () => (
    <CorporateSalesRefundsContainer />
);

export default CorporateSalesRefundsListPage;
